import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminLaunchControl = lazy(() => import("@/pages/admin/AdminLaunchControl"));

export const Route = createFileRoute("/admin/launch-control")({
  component: AdminLaunchControl,
});
